import { useState } from "react";
import { useModalReturnType } from "@pankod/refine-core";
import {
  Button,
  Form,
  Input,
  Modal,
} from "@pankod/refine-antd";

import { IOrder } from "interfaces";
import { create } from "requests/refunds";

interface Props {
  modal: useModalReturnType;
  order: IOrder;
  onUpdate: () => void;
}

const CreateRefundModal: React.FC<Props> = ({ modal, order, onUpdate }) => {
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  const onSubmit = async ({ motive }: { motive: string }) => {
    setLoading(true);

    try {
      await create({ orderId: order.id, motive });
      modal.close();
      onUpdate();
    } catch {
    } finally {
      setLoading(false);
    }
  }

  const onClick = async () => {
    const { motive } = await form.validateFields();

    onSubmit({ motive });
  }

  return (
    <Modal
      title="Criar Reembolso"
      visible={modal.visible}
      onCancel={modal.close}
      footer={[
        <Button key="back" onClick={modal.close}>
          Cancelar
        </Button>,
        <Button
          key="submit"
          type="primary"
          loading={loading}
          onClick={onClick}>
          Criar
        </Button>
      ]}
    >
      <Form form={form} layout="vertical" preserve={false}>
        <Form.Item label="Motivo" name="motive" required>
          <Input.TextArea rows={4} />
        </Form.Item>
      </Form>
    </Modal>
  )
};

export default CreateRefundModal;
